/* globals console, document, google, module, navigator,  require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Marionette = require('backbone.marionette'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    //
    configuration = require('../utilities/configuration'),
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'map'
    },
    geolocationMarker: undefined,
    map: undefined,
    markers: null,
    tagName: 'div',
    template: templates.map,
    ui: {
        mapCanvas: 'div[name=mapCanvas]'
    },
    //
    addMarker: function (latitude, longitude, options, via) {
        const marker = new google.maps.Marker({
                position: new google.maps.LatLng(latitude, longitude),
                anchorPoint: new google.maps.Point(0, -29),
                draggable: options.draggable === true ? true : false,
                payload: options.payload,
                icon: options.icon
            }),
            trigger = _.bind(function (options) {
                this.trigger('click:marker', options);
            }, this);
        if (_.indexOf(this.markers, marker) === -1) {
            this.markers.push(marker);
            marker.setMap(this.map);
            marker.addListener('click', function () {
                if (this.payload) {
                    trigger(this.payload);
                }
            });
        }
        if (options.draggable) {
            marker.addListener('dragend', _.bind(function (marker) {
                this.fitBounds();
                this.trigger('latitudeLongitude:updated', {latitude: marker.latLng.lat(), longitude: marker.latLng.lng()});
            }, this));
        }
        // console.log('map.addMarker - markers:%s', this.markers.length);
        return marker;
    },
    centerMap: function (latitudeLongitude) {
        const bounds = new google.maps.LatLngBounds(),
            latLng = new google.maps.LatLng(latitudeLongitude.latitude, latitudeLongitude.longitude);
        bounds.extend(latLng);
        this.map.fitBounds(bounds);
        this.map.setZoom(7);
    },
    clearMarkers: function () {
        _.each(this.markers, _.bind(function (marker) {
            if (marker !== this.geolocationMarker) {
                marker.setMap(null);
            }
        }, this));
        this.markers = [];
    },
    fitBounds: function () {
        const bounds = new google.maps.LatLngBounds();
        _.each(this.markers, function (marker) {
            bounds.extend(marker.getPosition());
        });
        if (this.geolocationMarker) {
            bounds.extend(this.geolocationMarker.getPosition());
        }
        this.map.fitBounds(bounds);
    },
    geolocation: function (latitude, longitude) {
        if (this.geolocationMarker) {
            this.geolocationMarker.setMap(null);
        }
        if (latitude !== -1 && longitude !== -1) {
            this.geolocationMarker = this.addMarker(latitude, longitude, {draggable: true, icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/library_maps.png'}, 'map');
        } else {
            this.geolocationMarker = null;
        }
        this.fitBounds();
    },
    initialize: function () {
        this.markers = [];
        this.sansControls = this.options.sansControls === true;
        this.maxZoom = this.options.maxZoom || 17;
    },
    onRender: function () {
        const latitude = configuration.mapStart.latitude,
            longitude = configuration.mapStart.longitude;
        let input,
            infowindowContent;
        this.map = new google.maps.Map(this.ui.mapCanvas[0], {
            mapTypeControl: false,
            streetViewControl: false,
            zoom: this.maxZoom,
            disableDefaultUI: this.sansControls
        });
        this.map.cid = this.cid;
        this.map.setCenter({lat: latitude, lng: longitude});
        this.fitBounds();
        google.maps.event.addListener(this.map, 'bounds_changed', _.bind(function (event) {
            // console.log(this.map.getZoom());
            if (this.map.getZoom() > this.maxZoom) {
                this.map.setZoom(this.maxZoom);
            }
        }, this));
    }
});
